(function () {
  'use strict';

  var BF_TIME_SELECTOR = '#bf-time';

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function getMidnightCountdown() {
    var now = new Date();

    if (now.getHours() === 0 && now.getMinutes() === 0) {
      return '00:00:00';
    }

    var target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    var diff = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
    var hours = Math.floor((diff % 86400) / 3600);
    var minutes = Math.floor((diff % 3600) / 60);
    var seconds = diff % 60;

    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function getAnnouncementBarTime() {
    var bfTime = document.querySelector(BF_TIME_SELECTOR);
    if (!bfTime) return null;

    var value = (bfTime.textContent || '').trim();
    return /^\d{2}:\d{2}:\d{2}$/.test(value) ? value : null;
  }

  function updateCountdown() {
    var node = document.querySelector('[data-elios-sellout-countdown]');
    if (!node) return;

    node.textContent = getAnnouncementBarTime() || getMidnightCountdown();
  }

  function init() {
    updateCountdown();
    setInterval(updateCountdown, 1000);

    var bfTime = document.querySelector(BF_TIME_SELECTOR);
    if (bfTime) {
      new MutationObserver(updateCountdown).observe(bfTime, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
